import { ShopperAiSettingsOptimizationType } from "@redotech/redo-model/shopper-ai-settings-optimization";
import { SettingsOptimizationDefinition } from "../optimization-types";
import { bundlesOptimization } from "./bundles-optimization";
import { discountsOptimization } from "./discounts-optimization";
import { orderEditingSkillsOptimization } from "./order-editing-skills-optimization";

export const settingsOptimizationDefinitions: Record<
  ShopperAiSettingsOptimizationType,
  SettingsOptimizationDefinition
> = {
  [ShopperAiSettingsOptimizationType.BUNDLES_OPTIMIZATION]: bundlesOptimization,
  [ShopperAiSettingsOptimizationType.DISCOUNTS_OPTIMIZATION]:
    discountsOptimization,
  [ShopperAiSettingsOptimizationType.ORDER_EDITING_SKILLS_OPTIMIZATION]:
    orderEditingSkillsOptimization,
};
